import { render, staticRenderFns } from "./ServiceProviderOverview.vue?vue&type=template&id=639541ca&scoped=true&"
import script from "./ServiceProviderOverview.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639541ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
